export default "__VITE_ASSET__EnT4vjgS__"